import NotificationsIconOutlined from "@mui/icons-material/NotificationsOutlined";
import {
  Badge,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchNotifications,
  markNotificationAsSeen,
} from "../../redux/Actions/notificationActions";
import useWebSocketNotifications from "./useWebSocketNotifications";

const NotificationMenu = ({ studentId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  useWebSocketNotifications();

  const { notifications } = useSelector((state) => state.notification);
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);

  const unseenCount = Array.isArray(notifications)
    ? notifications.filter((n) => !n.seen).length
    : 0;

  const handleNotifClick = (event) => {
    setNotifAnchorEl(event.currentTarget);
    if (studentId) dispatch(fetchNotifications(studentId));
  };

  const handleNotifClose = () => setNotifAnchorEl(null);

  const handleNotificationClick = (notif) => {
    dispatch(markNotificationAsSeen(notif.id, studentId));
    handleNotifClose();
    if (notif.teacherCourseId) {
      navigate(`/dashboard/enrolled-course/${notif.teacherCourseId}`);
    } else {
      // For general messages (like consultant feedback)
      navigate(`/dashboard/student/submissions`);
    }
  };

  const sortedNotifications = [...(notifications || [])].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );

  return (
    <>
      <Tooltip title="Notifications" arrow>
        <IconButton
          onClick={handleNotifClick}
          sx={{ color: unseenCount > 0 ? "primary.main" : "text.primary" }}
        >
          <Badge badgeContent={unseenCount} color="error">
            <NotificationsIconOutlined />
          </Badge>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={notifAnchorEl}
        open={Boolean(notifAnchorEl)}
        onClose={handleNotifClose}
        sx={{ zIndex: isMobile && 1800 }}
        PaperProps={{
          sx: {
            backgroundColor: "background.paper",
            color: "text.primary",
            width: 360,
            maxHeight: 420,
            overflowY: "auto",
            borderRadius: 2,
            boxShadow: 4,
          },
        }}
      >
        <Box sx={{ p: 1 }}>
          {Array.isArray(notifications) && notifications.length === 0 ? (
            <Typography variant="body2" sx={{ p: 2, textAlign: "center" }}>
              No notifications.
            </Typography>
          ) : (
            sortedNotifications.map((notif, index) => (
              <Box key={notif.id}>
                <MenuItem
                  onClick={() => handleNotificationClick(notif)}
                  sx={{
                    fontWeight: notif.seen ? "normal" : "bold",
                    backgroundColor: notif.seen ? "inherit" : "action.hover",
                    "&:hover": { backgroundColor: "action.selected" },
                    whiteSpace: "normal",
                    alignItems: "flex-start",
                  }}
                >
                  <Box>
                    <Typography variant="body2">
                      {notif.message?.trim() || "إشعار جديد"}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", mt: 0.5 }}
                    >
                      {new Date(notif.timestamp).toLocaleString()}
                    </Typography>
                  </Box>
                </MenuItem>
                {index < sortedNotifications.length - 1 && (
                  <Divider variant="middle" />
                )}
              </Box>
            ))
          )}
        </Box>
      </Menu>
    </>
  );
};

export default NotificationMenu;
